var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVipBenefit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.334 91.333c9.352 0 16.933-2.387 16.933-5.333 0-2.945-7.581-5.333-16.933-5.333S36.4 83.055 36.4 86c0 2.946 7.582 5.333 16.934 5.333z",
    fill: "#0C0A0C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.267 49.867L21.333 81.2 15.6 66.8h.133c5.334-1.2 9.067-5.467 8.134-9.467-.934-4.133-6-6.4-11.334-5.333-.933.133-1.733.4-2.4.8L4 37.333 73.867 18.4l12.4 31.467z",
    fill: "#FF794F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.667 33.867l11.867 31.2",
    stroke: "#0C0A0C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.934 33.2L67.6 40.4l5.867 8.667-10.667-2-5.866 7.733-1.6-9.2-8.934-4.933 9.467-2.934L57.2 28l5.867 7.2 9.867-2z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2 8.8l-8.4 8.133M75.867 3.467c0 3.2-.667 6.533-1.867 9.866M92 22.133L81.865 23.2",
    stroke: "#0C0A0C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgVipBenefit;